import { Accordion, AccordionItem, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow } from "carbon-components-react";
import React from "react";
//RITM0615454_DEV615_MatriciOutcomes
export default function AssestmentLevelTableLegend() {
	return (
		<Accordion className="legenda">
			<AccordionItem className="" title="Legenda">
				<TableContainer>
					<Table className="legend-mobile">
						<TableHead>
							<TableRow>
								<TableHeader colSpan={9}>CONSEQUENCE</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={1}>SEVERITY OF INCIDENT</TableHeader>
								<TableHeader colSpan={1}>INJURY TO PERSONS</TableHeader>
								<TableHeader colSpan={1}>DAMAGE TO ASSETS</TableHeader>
								<TableHeader colSpan={6}>EFFECTS ON ENVIRONMENT</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={1}></TableHeader>
								<TableHeader colSpan={1}></TableHeader>
								<TableHeader colSpan={1}></TableHeader>
								<TableHeader colSpan={1}>SPATIAL EXTENSION</TableHeader>
								<TableHeader colSpan={1}>IMPACT ON HIGH VULNERABLE AREAS</TableHeader>
								<TableHeader colSpan={1}>CLEAN UP INTERVENTION/REMEDIATION</TableHeader>
								<TableHeader colSpan={1}>LOCAL COMMUNITIES IMPACT</TableHeader>
								<TableHeader colSpan={1}>REQUIREMENTS/AUTHORITIES</TableHeader>
								<TableHeader colSpan={1}>REPUTATIONAL IMPACT</TableHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key="1" className="gray">
								<TableCell key="1.1">1 Negligible</TableCell>
								<TableCell key="1.2">Slight injury or limited health effects(First Aid)</TableCell>
								<TableCell key="1.3">
									Slight damage <br /> No disruption to operation
								</TableCell>
								{/* RITM1102955 */}
								<TableCell key="1.4">Very Minor</TableCell>
								<TableCell key="1.5">Not impacted</TableCell>
								<TableCell key="1.6">Managed with internal emergency team</TableCell>
								<TableCell key="1.7">Not impacted</TableCell>
								<TableCell key="1.8">Reporting not necessary</TableCell>
								<TableCell key="1.9">Not reported in the news</TableCell>
							</TableRow>
							<TableRow key="2" className="gray">
								<TableCell key="2.1">2 Low</TableCell>
								<TableCell key="2.2">
									Minor injury
									<br /> Effects on health (Medical Treatment or Work restricted case)
								</TableCell>
								<TableCell key="2.3">
									Minor damage <br /> Brief disruption (cost10K€-100K€ or 1day downtime)
								</TableCell>
								{/* RITM1102955 */}
								<TableCell key="2.4">Minor pollution contained at site level and that doesn’t spread on the environmental media</TableCell>
								<TableCell key="2.5">Not impacted</TableCell>
								<TableCell key="2.6">Managed with internal emergency team</TableCell>
								<TableCell key="2.7">Not impacted</TableCell>
								<TableCell key="2.8">Reported to Local authority without any fines</TableCell>
								<TableCell key="2.9">Not reported in the news</TableCell>
							</TableRow>
							<TableRow key="3" className="gray">
								<TableCell key="3.1">3 Medium</TableCell>
								<TableCell key="3.2">
									Serious injury or health effects or temporary or permanent total invalidity
									<br /> (Lost Time Injury) <br />{" "}
								</TableCell>
								<TableCell key="3.3">
									Local damage <br /> Partial disruption (cost 100k€-500k€ or 1-7 days downtime)
								</TableCell>
								{/* RITM1102955 */}
								<TableCell key="3.4">Pollution of the environmental media, up to a medium area (within the operational site, or at most within a few km) with short term effect</TableCell>
								<TableCell key="3.5">Not impacted</TableCell>
								<TableCell key="3.6">Managed with internal emergency team</TableCell>
								<TableCell key="3.7">Might be impacted with no lasting effect</TableCell>
								<TableCell key="3.8">Reported to Local authority (Port Authority, etc) with negligible fines</TableCell>
								<TableCell key="3.9">Reported in Local News</TableCell>
							</TableRow>
							<TableRow key="4" className="gray">
								<TableCell key="4.1">4 High</TableCell>
								<TableCell key="4.2">Single fatality </TableCell>
								<TableCell key="4.3">
									Major damage <br /> Major disruption(cost 500k€-3M€ or 1-2 weeks downtime)
								</TableCell>
								{/* RITM1102955 */}
								<TableCell key="4.4">Pollution of the environmental media up to a vast area (beyond the site of the incident) with medium term effect</TableCell>
								<TableCell key="4.5">Impacted with short term effect</TableCell>
								<TableCell key="4.6">Required the intervention of external facilities</TableCell>
								<TableCell key="4.7">Impacted with short term effect (up to few months effect)</TableCell>
								<TableCell key="4.8">Reported to National authority (inspections, fines, stop of operations) with not negligible fines</TableCell>
								<TableCell key="4.9">Reported in National News</TableCell>
							</TableRow>
							<TableRow key="5" className="gray">
								<TableCell key="5.1">5 Very High</TableCell>
								<TableCell key="5.2">Multiple fatalities</TableCell>
								<TableCell key="5.3">
									Extensive damage <br /> Very mayor disruption (cost 3M€-10M€ or more than 2 weeks downtime)
								</TableCell>
								{/* RITM1102955 */}
								<TableCell key="5.4">Pollution of the environmental media up to a vast area (beyond the site of the incident) with long term effect</TableCell>
								<TableCell key="5.5">Impacted with medium or long term effect</TableCell>
								<TableCell key="5.6">Required the intervention of external facilities or remediation not possible</TableCell>
								<TableCell key="5.7">Impacted with medium or long term effect (significative time spawn effect)</TableCell>
								<TableCell key="5.8">Reported to National authority (inspections, fines, stop of operations) with not negligible fines</TableCell>
								<TableCell key="5.9">Reported in International News</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionItem>
		</Accordion>
	);
}
